<template>
    <v-layout justify-center>
        <v-responsive max-width="1200px" width="100%">
            <v-row class="mt-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">로그 목록</v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="pt-0 pb-0">
                    <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                </v-col>
            </v-row>

            <v-expand-transition>
                <logs-search/>
            </v-expand-transition>

            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-btn color="white" class="green--text" @click="excel"> <v-icon>mdi-file-excel</v-icon> 엑셀다운로드 </v-btn>
                </v-col>
            </v-row>
            
            <v-data-table :items="logs" :headers="headers" disable-sort disable-pagination hide-default-footer class="elevation-1">
                <template #[`item.no`]="{ item }">
                    {{ (page - 1) * limit + (+logs.indexOf(item) + 1) }}
                </template>
                <template #[`item.type`]="{ item }">
                    {{ LOG_TYPES[item.type]?.text }}
                </template>
                <template #[`item.createdAt`]="{ item }">
                    {{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
                </template>
            </v-data-table>
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import LogsSearch from "@/components/console/logs/logs-search.vue";
import api from "@/api";
import XLSX from "xlsx";
import { LOG_TYPES } from "@/assets/variables";

export default {
    components: {
        LogsSearch
    },
    data() {
        return {
            headers: [
                { text: "no", value: "no", align: "center", width: 50 },
                { text: "관리자", value: "user.name", align: "center", width: 100 },
                { text: "종류", value: "type", align: "center", width: 100 },
                { text: "내용", value: "content", align: "center", width: 100 },
                { text: "ip", value: "ip", align: "center", width: 100 },
                { text: "생성날짜", value: "createdAt", align: "center", width: 100 },
            ],
            LOG_TYPES,
            // page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            logs: [],
        };
    },
    computed: {
        params() {
            let { query } = this.$route;

            return query;
        },
        page() {
            return +(this.$route.query.page || "1");
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            try {
                var { summary, logs } = await api.console.common.logs.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.params,
                });

                this.logs = logs;
                this.summary = summary;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async edit(item) {
            this.editItem = Object.assign({}, item);
            this.shows = true;
        },

        async remove(item) {
            try {
                if (confirm("청약신청을 삭제하시겠습니까?")) {
                

                    await api.console.application.delete(item);
                    await this.search();

                    alert("삭제되었습니다");
                }
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async excel() {
            try {
                delete this.params.page;
                var { logs } = await api.console.common.logs.gets({
                    params: this.params,
                });

                var rows = logs.map((log) => ({
                    관리자: log?.user?.name || "",
                    종류: LOG_TYPES[log?.type].text,
                    내용: log?.content || "",
                    IP: log?.ip || "",
                    생성날짜: this.$dayjs(log?.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                }));

                var workbook = new XLSX.utils.book_new();
                var worksheet = XLSX.utils.json_to_sheet(rows);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, `로그목록_${this.$dayjs().format('YYYY_MM_DD_HHmmss')}.xlsx`);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.email : error.email);
            }
        },
    },
    watch: {
        params() {
            this.search();
        }
    }
};
</script>
